import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { CheckCircle, Clock } from 'lucide-react'; // Example icons

interface Milestone {
  id: number;
  title: string;
  description: string;
  status: 'completed' | 'in-progress' | 'planned';
  date?: string; // Optional date
}

// Updated Roadmap Data
const roadmapData: Milestone[] = [
  // Completed
  { id: 1, title: 'Initial Setup & Landing Page', description: 'Project structure, base UI, and main page.', status: 'completed', date: 'Q1 2025' },
  { id: 2, title: 'User Authentication Setup', description: 'Basic sign-up and login pages.', status: 'completed', date: 'Q2 2025' },
  { id: 3, title: 'Plaid Integration', description: 'Connect bank accounts via Plaid for automatic transaction import.', status: 'completed', date: 'Q2 2025' },
  { id: 4, title: 'Roadmap Component', description: 'Displaying the development plan.', status: 'completed', date: 'Q2 2025' },
  // In Progress
  { id: 5, title: 'Core Budgeting Logic', description: 'Implement expense tracking, categories, and budget setting.', status: 'in-progress', date: 'Q2/Q3 2025' },
  { id: 6, title: 'Reporting Dashboard (Initial)', description: 'Develop basic reports and data visualization.', status: 'in-progress', date: 'Q3 2025' },
  // Planned
  { id: 7, title: 'Goal Setting Module', description: 'Allow users to set and track financial goals.', status: 'planned', date: 'Q3 2025' },
  { id: 8, title: 'UI/UX Refinements', description: 'Improve overall application look, feel, and flow.', status: 'planned', date: 'Q4 2025' },
  { id: 9, title: 'Testing & Deployment Prep', description: 'Comprehensive testing and deployment setup.', status: 'planned', date: 'Q4 2025' },
  { id: 10, title: 'Mobile App Development', description: 'Potential native iOS and Android applications.', status: 'planned', date: '2026' },
];

const getStatusIcon = (status: Milestone['status']) => {
  switch (status) {
    case 'completed':
      return <CheckCircle className="h-5 w-5 text-green-500" />;
    case 'in-progress':
      return <Clock className="h-5 w-5 text-yellow-500 animate-pulse" />;
    case 'planned':
      return <Clock className="h-5 w-5 text-gray-400" />;
    default:
      return null;
  }
};

const Roadmap: React.FC = () => {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="text-2xl font-semibold tracking-tight text-center">
          Our Development Roadmap
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {roadmapData.map((milestone) => (
          <div key={milestone.id} className="flex items-start gap-4 p-4 border rounded-lg shadow-sm bg-card">
            <div className="mt-1">
              {getStatusIcon(milestone.status)}
            </div>
            <div className="flex-1">
              <h3 className="font-semibold">{milestone.title}</h3>
              <p className="text-sm text-muted-foreground">{milestone.description}</p>
              {milestone.date && (
                <p className="text-xs text-muted-foreground mt-1">{milestone.date}</p>
              )}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default Roadmap; 